import { Link } from 'react-router-dom';

export default function BrandPromiseBanner() {
  return (
    <section className="bg-primary-500 w-full px-4 md:px-8 lg:px-12 py-12 md:py-14">
      <div className="max-w-6xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-600 rounded-full mb-6">
          <i className="ri-footprint-line text-accent-500 text-sm"></i>
          <span className="text-background-50/80 text-xs font-medium tracking-wide uppercase">Our Promise</span>
        </div>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4 leading-tight">
          "Safe Enough to Trust. Tough Enough to Last."
        </h2>
        <p className="text-primary-200 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          Every PounceBounce product is designed, tested, and crafted to meet one standard: would we give it to our own pets? If the answer isn't an immediate yes, it never makes the cut.
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-500 rounded-full font-bold text-sm hover:bg-secondary-100 transition-colors duration-200"
        >
          Learn About Our Materials
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}